import React from "react";
import "./FilterDates.scss";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import dayjs from "dayjs";

interface ActivitiesFilterDatesProps {
  formik: any;
  lable?: string;
}

const ActivitiesFilterDates: React.FC<ActivitiesFilterDatesProps> = ({ formik, lable }) => {
  const onChangeStartDate = (e: any) => {
    if (e) {
      formik.setFieldValue("startDate", dayjs(e).format("YYYY-MM-DD"));
    }
  };

  const onChangeEndDate = (e: any) => {
    if (e) {
      formik.setFieldValue("endDate", dayjs(e).format("YYYY-MM-DD"));
    }
  };

  return (
    <div className="filter-new-date-contain">
      <p className="date-head">{lable ? lable : "Created Date"}</p>

      <div className="start-date filter-date-input-contain">
        <p className="date-lable">Start Date</p>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DesktopDatePicker
            value={formik?.values?.startDate ? dayjs(formik.values.startDate) : null}
            onChange={onChangeStartDate}
            format="DD/MM/YYYY"
            slotProps={{
              textField: {
                fullWidth: true,
                size: "small",
                className: "filter-date-input",
              },
            }}
          />
        </LocalizationProvider>
      </div>

      <div className="start-date filter-date-input-contain">
        <p className="date-lable">End Date</p>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DesktopDatePicker
            value={formik?.values?.endDate ? dayjs(formik.values.endDate) : null}
            onChange={onChangeEndDate}
            format="DD/MM/YYYY"
            slotProps={{
              textField: {
                fullWidth: true,
                size: "small",
                className: "filter-date-input", 
              },
            }}
          />
        </LocalizationProvider>
      </div>
    </div>
  );
};

export default ActivitiesFilterDates;
